<p>logstreams works!</p>
